export * from '../../../console/src/plugins/i18n'
